import GeneratorLoremIpsum from "../components/GeneratorLoremIpsum"

import "./Generator.css"

export const Generator = () => {
  return (
    <div>

      <GeneratorLoremIpsum />

    </div>
  )
}
export default Generator